export class UrlBuilder {
	private base: string;
	private args: string[] = [];

	constructor(base: string) {
		this.base = base;
	}

	set(nom: string, valeur?: any): UrlBuilder {
		if (valeur != null) {
			this.args[nom] = valeur.toString();
		}
		else {
			this.clear(nom);
		}
		return this;
	}

	reset(): UrlBuilder {
		this.args = [];
		return this;
	}

	clear(nom: string): UrlBuilder {
		delete this.args[nom];
		return this;
	}

	build(): string {
		let url = this.base;

		let urlArgs = [];
		for (let key in this.args) {
			urlArgs.push(key + '=' + this.args[key]);
		}
		url += '?' + urlArgs.join('&');
		return url;
	}
}
